var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FloatingAlert',_vm._g({attrs:{"is-shown":_vm.isShown,"text":_vm.flashMessage,"type":_vm.flashType}},( _obj = {}, _obj[_vm.emitEvents.emitEventWhenClickMessage] = _vm.hide, _obj )))}
var staticRenderFns = []

export { render, staticRenderFns }